import { Campaign } from '@components/campaign/Campaign'
import { CampaignEmployee } from '@components/campaignEmployee/CampaignEmployee'
import { Company } from '@components/company/Company'
import { Employee } from '@components/employee/Employee'
import { Form } from '@components/form/Form'
import { Job } from '@components/job/Job'
import { Campaign as CampaignModel } from '@models/Campaign'
import { Company as CompanyModel } from '@models/Company'
import { Employee as EmployeeModel } from '@models/Employee'
import { Form as FormModel } from '@models/Form'
import { FormItem as FormItemModel } from '@models/FormItem'
import { Job as JobModel } from '@models/Job'
import { SBModel } from '@models/SBmodel'
import { getAdminsSuccess } from '@store/AdminReducer'
import {
  getCampaignEmployeesSuccess,
  setSelectedCampaignEmployee,
} from '@store/CampaignEmployeeReducer'
import {
  getCampaignsSuccess,
  setSelectedCampaign,
} from '@store/CampaignReducer'
import { getCompaniesSuccess, setSelectedCompany } from '@store/CompanyReducer'
import {
  getEmployeesSuccess,
  setSelectedEmployee,
} from '@store/EmployeeReducer'
import { getFormsSuccess, setSelectedForm } from '@store/FormReducer'
import { getJobsSuccess, setSelectedJob } from '@store/JobReducer'
import { AppDispatch } from '@store/store'
import { getUsersSuccess } from '@store/UserReducer'
import { InitialConfig as SBAsyncSelectInitialConfig } from '@supplement-bacon/react-async-select'
import { NormalizedData } from '@supplement-bacon/react-toolkit/models'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { InitialConfig as SBRMInitialConfig } from '@supplement-bacon/sbrm-react'
import {
  CAMPAIGN_EMPLOYEE_URL,
  CAMPAIGN_URL,
  COMPANY_URL,
  EMPLOYEE_URL,
  FORM_ITEM_URL,
  FORM_URL,
  JOB_URL,
} from './urls'

enum Entity {
  job = 'job',
  company = 'company',
  employee = 'employee',
  form = 'form',
  formItem = 'formItem',
  campaign = 'campaign',
  campaignEmployee = 'campaignEmployee',
  admin = 'admin',
}

const generateConfig =
  () =>
  (
    dispatch: AppDispatch
  ): SBRMInitialConfig['entities'] &
    SBAsyncSelectInitialConfig<SBModel>['entities'] => ({
    [Entity.job]: {
      endpoint: JOB_URL,
      localizedLabel: 'Emploi',
      form: Job.Form,
      options: {
        renderLabel: (item: SBModel) => (
          <Job.Option model={item as unknown as JobModel} />
        ),
      },
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedJob(id))
        },
      },
    },
    [Entity.company]: {
      endpoint: COMPANY_URL,
      displayEmpty: true,
      form: Company.Form,
      options: {
        renderLabel: (item: SBModel) => (
          <Company.Option model={item as unknown as CompanyModel} />
        ),
      },
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedCompany(id))
        },
      },
    },
    [Entity.employee]: {
      endpoint: EMPLOYEE_URL,
      displayEmpty: true,
      form: Employee.Form,
      options: {
        renderLabel: (item: SBModel) => (
          <Employee.Option
            size={'small'}
            model={item as unknown as EmployeeModel}
          />
        ),
      },
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedEmployee(id))
        },
      },
    },
    [Entity.form]: {
      endpoint: FORM_URL,
      displayEmpty: true,
      form: Form.Form,
      options: {
        renderLabel: (item: SBModel) => (
          <>{(item as unknown as FormModel).name}</>
        ),
        addExtraAttributes: (item: SBModel) => ({
          name: (item as unknown as FormModel).name,
        }),
      },
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedForm(id))
        },
      },
    },
    [Entity.formItem]: {
      endpoint: FORM_ITEM_URL,
      displayEmpty: true,
      form: (<></>) as any,
      options: {
        renderLabel: (item: SBModel) => (
          <>{(item as unknown as FormItemModel).question}</>
        ),
        addExtraAttributes: (item: SBModel) => ({
          item: item,
          question: (item as unknown as FormItemModel).question,
        }),
      },
      methods: {
        setSelected: (id: any) => {
          // Not used
        },
      },
    },
    [Entity.campaign]: {
      endpoint: CAMPAIGN_URL,
      form: Campaign.Form,
      options: {
        renderLabel: (item: SBModel) => (
          <Campaign.Option model={item as unknown as CampaignModel} />
        ),
        addExtraAttributes: (item: SBModel) => ({
          name: (item as unknown as CampaignModel).name,
        }),
      },
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedCampaign(id))
        },
      },
    },
    [Entity.campaignEmployee]: {
      localizedLabel: "campagne d'employé",
      endpoint: CAMPAIGN_EMPLOYEE_URL,
      form: CampaignEmployee.Form,
      options: {
        renderLabel: (item: SBModel) => (
          <>{(item as unknown as CampaignModel).name}</>
        ),
      },
      methods: {
        setSelected: (id: any) => {
          dispatch(setSelectedCampaignEmployee(id))
        },
      },
    },
  })

SBAPI.fillStoreWithNormalizedData =
  (normalizedData: NormalizedData) => (dispatch: AppDispatch) => {
    dispatch(getAdminsSuccess(normalizedData.entities.admin ?? {}))
    dispatch(getCampaignsSuccess(normalizedData.entities.campaign ?? {}))
    dispatch(
      getCampaignEmployeesSuccess(
        normalizedData.entities.campaignEmployee ?? {}
      )
    )
    dispatch(getCompaniesSuccess(normalizedData.entities.company ?? {}))
    dispatch(getEmployeesSuccess(normalizedData.entities.employee ?? {}))
    dispatch(getFormsSuccess(normalizedData.entities.form ?? {}))
    dispatch(getJobsSuccess(normalizedData.entities.job ?? {}))
    dispatch(getUsersSuccess(normalizedData.entities.user ?? {}))
  }

export { Entity, generateConfig }
